import { z } from 'zod'
import { isWorkEmail } from './utils'

export const PERSONAL_EMAIL_DOMAINS = [
  'gmail.com',
  'googlemail.com',
  'yahoo.com',
  'outlook.com',
  'hotmail.com',
  'aol.com',
  'icloud.com',
  'mail.com',
  'protonmail.com',
  'yandex.com',
  'gmx.com',
  'live.com',
  'msn.com',
  'me.com',
  'mac.com',
]

/** Personal inboxes that may still sign up and log in (local QA). */
export const TEST_USER_EMAILS = ['alfredodling@gmail.com']

export const DEBOUNCE_DELAY = 500
export const BRANDFETCH_BASE_URL = 'https://cdn.brandfetch.io'
export const BRANDFETCH_API_KEY = '1idPWY0AiNqr7y_koY9'

export const BUSINESS_OAUTH_PROVIDERS = ['google', 'azure'] as const
export type BusinessOAuthProvider = (typeof BUSINESS_OAUTH_PROVIDERS)[number]

export const createFormSchema = () => {
  return z.object({
    email: z
      .string()
      .email('Please enter a valid email address')
      .refine((val) => isWorkEmail(val), {
        message:
          'This email appears to be a personal email. Please use a work email address instead.',
      }),
  })
}
